import i18n from "i18next"

type Translations = Record<string, string>

export const unknownErrorToString = (
  error: unknown,
  defaultMessage: string | Translations = "Unknown error",
  translations?: Translations
): string => {
  translations = translations || (typeof defaultMessage === "object" ? defaultMessage : {})
  defaultMessage = typeof defaultMessage === "string" ? defaultMessage : "Unknown error"

  if (error instanceof Error) return error.message
  if (typeof error === "string") return error

  const translatedMessage = getTranslatedMessageFromApiError(error, translations)
  if (translatedMessage) return translatedMessage

  const mayBeApiError = getMessageFromApiError(error)
  if (mayBeApiError) return mayBeApiError

  if (typeof error === "object" && error !== null) {
    if ("message" in error) return unknownErrorToString(error.message)
    if ("error" in error) return unknownErrorToString(error.error)
    if ("detail" in error) return unknownErrorToString(error.detail)

    const stringified = String(error)
    if (stringified === "[object Object]") return defaultMessage
    else return stringified
  }

  return defaultMessage
}

// extract the first message from NormalizedError with shape { status: number, data: { code: string, message?: string }[] }
const getMessageFromApiError = (error: unknown): string | null => {
  if (typeof error !== "object") return null
  if (error === null) return null
  if (!("data" in error)) return null
  if (!Array.isArray(error.data) || error.data.length < 1) return null
  let message = null
  for (const item of error.data) {
    message = "message" in item ? item.message : null
    if (message) break
  }
  return message
}

const getCodeFromApiError = (error: unknown): string | null => {
  if (typeof error !== "object") return null
  if (error === null) return null
  if (!("data" in error)) return null
  if (!Array.isArray(error.data) || error.data.length < 1) return null
  let code = null
  for (const item of error.data) {
    code = "code" in item ? item.code : null
    if (code) break
  }
  return code
}

const getTranslatedMessageFromApiError = (error: unknown, translations: Record<string, string> = {}): string | null => {
  const code = getCodeFromApiError(error)
  if (!code) return null

  const translatedMessage = translations[code]
  if (translatedMessage) return translatedMessage

  if (!i18n.exists(code, { ns: "errors" })) return null
  return i18n.t(code, { ns: "errors" })
}

export const errorToMessage = unknownErrorToString
